module.exports = __webpack_public_path__ + "img/buyCardGiftPop_bg.1a2743bf.png";